import React, { PureComponent } from 'react'
import moment from 'moment'
import { URIS } from '../../Uris'
import { ENV } from '../../environment'

import { grant, generateUrl } from '../Utils/Service'

class MemberDetails extends PureComponent {
  render () {
    const m = this.props.member
    const expanded = this.props.expanded
    return (
      <div className={'member-item ' + m.course_color}>
        <ul className="member-header">
          <li className="member-avatar">
            <img src={m.avatar} alt='usr' className="avatar" />
          </li>
          <li className="member-name">
            <span>Cognome Nome</span>
            {m.surname} {m.name}&nbsp;
          </li>
          <li className={'member-status ' + ((m.active) ? 'green' : 'red')}>
            <i className="fas fa-circle"></i>
            Socio Attivo
          </li>
          <li className={'member-status ' + ((m.insurance_active) ? 'green' : 'red')}>
            <i className="fas fa-circle"></i>
            Assicurazione
          </li>
          <li className={'member-status ' + ((m.medical_certificate_valid) ? 'green' : 'red')}>
            <i className="fas fa-circle"></i>
            Certificato medico {m.medical_certificate_valid}
          </li>
          <li className="info-buttons">
            {
              m.medical_certificate_checksum !== '' && (
                <a href={generateUrl(ENV.production, URIS.doc, m.id, m.medical_certificate_checksum)} className="lnk-edits" target="_blank" title="Certificato medico"><i className="fas fa-file-alt"></i></a>
              )
            }
            {
              grant() && (
                <button className="lnk-edits" onClick={() => this.props.showEdit(m)}><i className="fas fa-edit"></i></button>
              )
            }
            {
              grant() && (
                <button className="lnk-edits" onClick={() => this.props.showDelete(m)}><i className="fas fa-trash-alt"></i></button>
              )
            }
          </li>
        </ul>
        <ul className={'member-body ' + (expanded ? 'expanded' : '') }>
          <li>
            <span>Codice fiscale</span>
            {m.fiscal_code}&nbsp;
            <span>Data di nascita</span>
            {(m.born_date !== '') ? moment.unix(m.born_date).format('ll') : ''}&nbsp;
            <span>Età</span>
            {m.age}&nbsp;
            <span>Tshirt</span>
            {m.tshirt_size}&nbsp;
            <span>Qualifica</span>
            {m.title}&nbsp;
          </li>
          <li>
            <span>Corso</span>
            {m.course_name}&nbsp;
            <span>Email</span>
            {m.email}&nbsp;
            <span>Cellulare</span>
            {m.mobile}&nbsp;
            <span>Telefono</span>
            {m.phone}&nbsp;
          </li>
          <li>
            <span>Indirizzo</span>
            {m.address}&nbsp;
            <span>Città</span>
            {m.city}&nbsp;
            <span>Provincia</span>
            {m.country}&nbsp;
            <span>Tutore legale</span>
            {m.tutor_name}&nbsp;
          </li>
        </ul>
      </div>
    )
  }
}

export default MemberDetails



// WEBPACK FOOTER //
// ./src/components/Members/MemberDetails.js